import type { GroceryCategory, Store } from '@recipes/contracts';
import { orderGroceryCategories } from '@recipes/domain';

/**
 * The order of a store's departments for the shopping list: a branch without an order of its
 * own walks like its chain, a store without any like the default.
 */
export function departmentOrderOf(store: Store | null, stores: Store[]): GroceryCategory[] {
  if (!store) return orderGroceryCategories(null);
  const own = store.departmentOrder ?? [];
  if (own.length > 0) return orderGroceryCategories(own);
  const chain = store.parentStoreId ? stores.find((s) => s.id === store.parentStoreId) : null;
  return orderGroceryCategories(chain?.departmentOrder);
}
